import React from 'react';
import { Footer as FlowbiteFooter } from 'flowbite-react';

export default function Footer() {
  return (
    <FlowbiteFooter container className="mt-auto border-t">
      <div className="w-full">
        <div className="grid w-full justify-between sm:flex sm:justify-between md:flex md:grid-cols-1">
          <div className="mb-4">
            <div className="flex items-center">
              <span className="text-2xl mr-2">🏠</span>
              <span className="text-xl font-bold">
                <span className="text-blue-600">Real</span>
                <span className="text-gray-800">gram</span>
              </span>
            </div>
            <p className="text-sm text-gray-500 mt-2">
              Платформа для управления недвижимостью
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:mt-4 sm:grid-cols-3 sm:gap-6">
            <div>
              <FlowbiteFooter.Title title="Продукт" />
              <FlowbiteFooter.LinkGroup col>
                <FlowbiteFooter.Link href="#">Возможности</FlowbiteFooter.Link>
                <FlowbiteFooter.Link href="#">Тарифы</FlowbiteFooter.Link>
                <FlowbiteFooter.Link href="#">API</FlowbiteFooter.Link>
              </FlowbiteFooter.LinkGroup>
            </div>
            <div>
              <FlowbiteFooter.Title title="Поддержка" />
              <FlowbiteFooter.LinkGroup col>
                <FlowbiteFooter.Link href="#">Документация</FlowbiteFooter.Link>
                <FlowbiteFooter.Link href="#">Помощь</FlowbiteFooter.Link>
                <FlowbiteFooter.Link href="#">Контакты</FlowbiteFooter.Link>
              </FlowbiteFooter.LinkGroup>
            </div>
            <div>
              <FlowbiteFooter.Title title="Компания" />
              <FlowbiteFooter.LinkGroup col>
                <FlowbiteFooter.Link href="#">О нас</FlowbiteFooter.Link>
                <FlowbiteFooter.Link href="#">Блог</FlowbiteFooter.Link>
                <FlowbiteFooter.Link href="#">Карьера</FlowbiteFooter.Link>
              </FlowbiteFooter.LinkGroup>
            </div>
          </div>
        </div>
        <FlowbiteFooter.Divider />
        <div className="w-full sm:flex sm:items-center sm:justify-between">
          <FlowbiteFooter.Copyright 
            by="Realgram™" 
            href="#" 
            year={new Date().getFullYear()} 
          />
          <div className="mt-4 flex space-x-6 sm:mt-0 sm:justify-center">
            <span className="text-sm text-gray-500">
              Сделано с ❤️ для агентов недвижимости
            </span>
          </div>
        </div>
      </div>
    </FlowbiteFooter>
  );
}